import React, { Component } from 'react';
import Immutable from 'immutable';
import { withStyles } from '@material-ui/core/styles';
// import Box from "@material-ui/core/Box";
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
// import Button from "@material-ui/core/Button";
import Grid from '@material-ui/core/Grid';
import { formatDate } from 'helpers/stringUtils';
import combine from 'mout/array/combine';
import filter from 'mout/array/filter';
// import BlockTitle from "components/UI/BlockTitle";
// import EventCardSimple from "components/Event/EventCardSimple";
// import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import Box from '@material-ui/core/Box';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
// import EventSubscription from "components/EventSubscription/EventSubscription";
// import PopinWrapper from "components/PopinWrapper";
// import EventSubscriptionVisitor from "components/EventSubscription/EventSubscriptionVisitor";
// import EventSubscriptionFor from "components/EventSubscription/EventSubscriptionFor";
// import DialogPopinButton from "components/UI/Dialog/DialogPopinButton";
// import Paper from "@material-ui/core/Paper";
// import {
//   withRouter
// } from "react-router-dom";
// import i18n from "helpers/i18n";
const styles = (theme) => {
  return {
    root: {
      // maxWidth: 1280,
      // margin: "0 auto 30px",
      cursor: 'pointer',
      '& .MuiTypography-subtitle1': {
        color: '#fff',
        fontSize: '1rem',
        display: 'block',
        textAlign: 'center',
        width: '100%',
        fontWeight: 'bold',
      },
      '& .MuiTypography-subtitle2': {
        color: '#fff',
        fontSize: '1.5rem',
        display: 'block',
        textAlign: 'center',
        width: '100%',
        fontWeight: 'bold',
      },
    },
    dateWrapper: {
      padding: 10,
      // backgroundColor: theme.palette.primary.main,
      backgroundImage: 'url(' + require('@assets/images/' + process.env.REACT_APP_SITE + '/bubble.png') + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'contain',
      position: 'relative',
      width: 250,
      height: 250,
      //     -webkit-touch-callout: none; /* iOS Safari */
      // -webkit-user-select: none; /* Safari */
      //  -khtml-user-select: none; /* Konqueror HTML */
      //    -moz-user-select: none; /* Old versions of Firefox */
      //     -ms-user-select: none; /* Internet Explorer/Edge */
      userSelect: 'none',
      transition: [
        theme.transitions.create('background-color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        theme.transitions.create('color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      ],
      '& .MuiTypography-body1': {
        fontSize: '14px',
        lineHeight: '22px',
        letterSpacing: '1.17px',
        fontStyle: 'normal',
        // color: theme.palette.common.black,
        // fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
          fontSize: '12px',
          lineHeight: '16px',
        },
      },
    },
    dateFull: {
      backgroundImage:
        'url(' + require('@assets/images/' + process.env.REACT_APP_SITE + '/bubble_disabled.png') + ')',
    },
    dateWrapperSelected: {
      // backgroundColor: theme.palette.secondary.main,
      backgroundImage:
        'url(' + require('@assets/images/' + process.env.REACT_APP_SITE + '/bubble_selected.png') + ')',
      '& .MuiTypography-subtitle1, .MuiTypography-subtitle2 ': {
        color: theme.palette.text.light,
      },
    },
    subscriptionState: {
      position: 'absolute',
      right: 5,
      top: 5,
    },
    inline: {
      display: 'inline-block',
    },
    disabled: {
      opacity: 0.5,
    },
    dateFullLegend: {
      // position: 'absolute',
      // top: 20,
      // padding: '5px 10px',
      // right: '-30px',
      // transform: 'rotate(35deg)',
      // fontSize: '1.5rem',
      // backgroundColor: theme.palette.secondary.main,
      // color: theme.palette.secondary.contrastText
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      width: '100%',
      fontSize: '1.5rem',
    },
    dateSelectedLegend: {
      color: '#fff',
      textAlign: 'center',
    },
    checkbox: {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginTop: '-4px',
      marginRight: '7px',
    },
  };
};
class EventTimeGrid extends Component {
  render() {
    const { userRole, selected, subscribed, $$card, classes, onClick } = this.props;
    return (
      <Grid item xs={12} sm={6} md={4} lg={3} className={classes.root}>
        <Grid
          align="center"
          item
          xs={12}
          container
          alignContent="center"
          className={clsx(classes.dateWrapper, {
            [classes.dateWrapperSelected]: selected,
            [classes.dateFull]: $$card.get('isFull') === 1,
          })}
          style={{ position: 'relative' }}
          onClick={
            onClick !== undefined
              ? (e) => {
                  e.preventDefault();
                  if ($$card.get('isFull') === 1 && subscribed !== true) return;
                  else onClick($$card.get('id'));
                }
              : undefined
          }
        >
          <Typography variant={'subtitle1'}>
            <If condition={selected === true}>
              <CheckBoxIcon className={classes.checkbox} />
            </If>
            {/* <If condition={selected !== true}>
              <CheckBoxOutlineBlankIcon />
              </If>
            */}
            {formatDate($$card.get('eventDate'), 'dddd dd mmmm')}
          </Typography>
          <Typography variant={'subtitle2'}>
            <span className={classes.inline}>{formatDate($$card.get('eventDate'), "HH'h'MM")}</span>
          </Typography>

          <If condition={$$card.get('isFull') === 1}>
            <Box className={classes.dateFullLegend}>Complet !</Box>
          </If>
        </Grid>
      </Grid>
    );
  }
}
// export default ;
export default withStyles(styles)(EventTimeGrid);



// WEBPACK FOOTER //
// ./src/components/Event/EventTimeGrid.jsx